// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"278":"polyfills-dom","329":"polyfills-core-js"}[chunkId] || chunkId) + "." + {"278":"bfcf4e2f","329":"eadbc823","387":"966448a6","503":"cf1537de"}[chunkId] + ".chunk.js";
};